export default __webpack_public_path__ + "static/media/uae-pass.8fcf6d63.png";